"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateProvider = exports.DateProvider = void 0;
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var date_fns_2 = require("date-fns");
var locale_1 = require("date-fns/locale");
var instance;
/**
 * @class DateProvider
 *
 * Provider to DateAdapter
 */
var DateProvider = /** @class */ (function (_super) {
    __extends(DateProvider, _super);
    function DateProvider() {
        return _super.call(this) || this;
    }
    DateProvider.getInstance = function () {
        if (!instance)
            instance = new DateProvider();
        return instance;
    };
    DateProvider.prototype.getLocale = function () {
        return this.locale;
    };
    DateProvider.prototype.setLocale = function (value) {
        switch (value) {
            case 'es':
                this.locale = locale_1.es;
                break;
            case 'en':
                this.locale = locale_1.enUS;
                break;
            default:
                break;
        }
    };
    DateProvider.prototype.getDay = function (date) {
        return (0, date_fns_2.getDay)(date);
    };
    return DateProvider;
}(date_fns_1.default));
exports.DateProvider = DateProvider;
exports.dateProvider = DateProvider.getInstance();
